import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";
import { useState, useRef, useEffect } from "react";

const testimonials = [
  { name: "Anna K.", text: "Świetny występ! Nasi pracownicy byli zachwyceni, a pozytywna energia utrzymywała się jeszcze przez wiele dni." },
  { name: "Marek N.", text: "Profesjonalne podejście i świetne dostosowanie żartów do naszej branży. Polecam!" },
  { name: "Katarzyna W.", text: "Kabaret był strzałem w dziesiątkę na naszej imprezie integracyjnej. Wszyscy świetnie się bawili!" },
  { name: "Tomasz L.", text: "Niesamowita energia i humor dostosowany idealnie do naszego zespołu. Na pewno zaprosimy ponownie!" },
  { name: "Monika S.", text: "Profesjonalizm na najwyższym poziomie. Występ przeszedł nasze najśmielsze oczekiwania." },
  { name: "Paweł D.", text: "Rewelacyjny wieczór pełen śmiechu. Pracownicy do dziś wspominają ten występ z uśmiechem." },
];

export const Testimonials = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkScroll();
    el.addEventListener("scroll", checkScroll);
    return () => el.removeEventListener("scroll", checkScroll);
  }, []);

  const scroll = (dir: "left" | "right") => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir === "left" ? -340 : 340, behavior: "smooth" });
  };

  return (
    <section className="py-24 bg-secondary">
      <div className="container">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="text-accent font-semibold text-sm uppercase tracking-widest">Opinie</span>
            <h2 className="text-4xl md:text-5xl font-montserrat font-black mt-3 text-foreground">
              Co mówią nasi Klienci?
            </h2>
          </div>
        </ScrollReveal>

        <div className="relative">
          {canScrollLeft && (
            <button onClick={() => scroll("left")} className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-background shadow-lg border border-border/50 flex items-center justify-center hover:bg-accent hover:text-accent-foreground transition-colors -ml-2">
              <ChevronLeft className="w-5 h-5" />
            </button>
          )}
          {canScrollRight && (
            <button onClick={() => scroll("right")} className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-background shadow-lg border border-border/50 flex items-center justify-center hover:bg-accent hover:text-accent-foreground transition-colors -mr-2">
              <ChevronRight className="w-5 h-5" />
            </button>
          )}

          <div ref={scrollRef} className="flex gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-4 px-1">
            {testimonials.map((t, i) => (
              <ScrollReveal key={t.name + i} delay={i * 100}>
                <div className="min-w-[300px] w-[300px] h-[280px] flex flex-col p-8 rounded-2xl bg-background shadow-lg border border-border/50 card-hover relative snap-start">
                  <Quote className="w-10 h-10 text-accent/20 absolute top-6 right-6" />
                  <div className="flex gap-1 mb-4">
                    {[1, 2, 3, 4, 5].map((j) => (
                      <Star key={j} className="w-4 h-4 text-accent-warm" fill="currentColor" />
                    ))}
                  </div>
                  <p className="font-inter text-muted-foreground leading-relaxed text-sm flex-1">{t.text}</p>
                  <div className="flex items-center gap-3 mt-4">
                    <div className="w-9 h-9 rounded-full bg-accent/10 flex items-center justify-center text-accent font-bold text-sm">
                      {t.name.charAt(0)}
                    </div>
                    <p className="font-montserrat font-bold text-foreground text-sm">{t.name}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
